<div [formGroup]="form" class="form-group questionBox">


  <div>
    @switch (normalizedControlType) {
      @case ('bigselectbox') {
        <div >
          <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
          <app-select-big-box [questionKey]="question.key" [questionBase]="question"></app-select-big-box>
        </div>
      }
      @case ('checkbox') {
        <label
          class="modern-checkbox-row"
          [class.is-disabled]="question.disabled"
          [attr.for]="question.key">
          <input
            class="modern-checkbox-input"
            [formControlName]="question.key"
            [id]="question.key"
            type="checkbox"
            (change)="valuechange($event)">
          <span class="modern-checkbox-control" aria-hidden="true">
            <svg viewBox="0 0 20 20">
              <path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path>
            </svg>
          </span>
          <span class="modern-checkbox-label">{{question.label}}</span>
        </label>
      }
      @case ('selectrelateddescription') {
        <div>
          <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
          <app-select-related-description [questionKey]="question.key"></app-select-related-description>
        </div>
      }
      @case ('textbox') {
        <div>
          <app-text-field [question]="question" [control]="form.get(question.key)" (onValueChange)="valuechange($event)"></app-text-field>
        </div>
      }
      @case ('textarea') {
        <div>
          <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
          <textarea
            class="form-control questionTag input-field-focus"
            [formControlName]="question.key"
            [id]="question.key"
            [attr.aria-label]="question.label"
            [attr.maxlength]="question.maxLength || null"
            (change)="valuechange($event)"></textarea>
          <!-- SCRUM-155: character counter, e.g. 0/400 -->
          @if (question.maxLength) {
            <div class="char-counter" dir="ltr">{{ (form.get(question.key)?.value || '').length }}/{{ question.maxLength }}</div>
          }
        </div>
      }
      @case ('dropdown') {
        <div>
          <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
          <app-ui-select-dropdown [questionBase]="question"></app-ui-select-dropdown>
          <!--      <app-dropdown [question]="question" [questionKey]="question.key"></app-dropdown>-->
          <!--      <select class="form-control questionTag" (click)="selectOnClick()" (scroll)="dropDownScroll($event)" (change)="updateMySelection($event)"  [id]="question.key"  [formControlName]="question.key">-->
          <!--        <option *ngFor="let opt of question.options" [value]="opt">{{opt.label}}</option>-->
        <!--      </select>-->
      </div>
    }
    @case ('multiselectbox') {
      <div >
        <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
        <app-multi-select-box></app-multi-select-box>
      </div>
    }
    @case ('imagesbox') {
      <div >
        <label class="questionLabel" [attr.for]="question.key">{{ question.label }}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
        <!-- Tabs header -->
        <div class="upload-tabs" role="tablist" aria-label="Upload tabs">
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeUploadTab === 'images'"
            (click)="activeUploadTab = 'images'"
            role="tab"
            [attr.aria-selected]="activeUploadTab === 'images'">
            <mat-icon class="tab-icon">image</mat-icon>
            <span>{{"sale4you.label.images" | translate}}</span>
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeUploadTab === 'videos'"
            (click)="activeUploadTab = 'videos'"
            role="tab"
            [attr.aria-selected]="activeUploadTab === 'videos'">
            <mat-icon class="tab-icon">videocam</mat-icon>
            <span>{{"sale4you.label.video"| translate}}</span>
          </button>
        </div>
        <!-- Tab content -->
        <div class="tab-content">
          @if (activeUploadTab === 'images') {
            <app-image-list></app-image-list>
          }
          @if (activeUploadTab === 'videos') {
            <app-story-video-uploader></app-story-video-uploader>
          }
        </div>
      </div>
    }
    @case ('personcontact') {
      <div>
        <label class="questionLabel" [attr.for]="question.key">{{question.label}}@if (question.required && $any(question.section)?.markRequired) {<span class="required-mark" aria-hidden="true"> *</span>}</label>
        <app-person-contact></app-person-contact>
      </div>
    }
  }
</div>
@if (!isValid) {
  <div class="errorMessage" role="alert">יש למלא את השדה {{question.label}}</div>
}
</div>
